export default __webpack_public_path__ + "static/media/playering5.4c0e6058.png";